<template>
  <common-field
      v-bind="commonFieldAttrs"
      class="show-label"
      borderless
      stack-label
      no-error-icon
      :error-message="activeErrorMessage"
      :error="hasError"
  >
    <template v-slot:control>
      <q-editor
          v-bind="allAttrs"
          required
          max-height="30vh"
          :model-value="modelValue"
          @update:modelValue="updated"
          @blur="checkRequired"
          content-class="rich-text-editor-style editor-styling"
          min-height="10rem"
          class="full-width"
          toolbar-color="neutral-60"
          :tabindex="0"
          :definitions="definitions"
          :toolbar="toolbar"
      />
      <input type="hidden" :value="modelValue" :name="name" />
    </template>
  </common-field>
</template>

<script>
import Base from './Base'
import { ref } from 'vue'

export default {
  extends: Base,
  emits: ['update:modelValue'],
  props: {
    required: Boolean,
    error: Boolean,
    errorMessage: '',
  },
  setup () {
    const definitions = {
      bold: {
        tip: 'Dikgedrukt',
      },
      italic: {
        tip: 'Cursief',
      },
      unordered: {
        tip: 'Ongenummerde lijst',
      },
      ordered: {
        tip: 'Genummerde lijst',
      },
    }

    const toolbar = [
      ['bold', 'italic', 'unordered', 'ordered'],
    ]

    return {
      definitions,
      toolbar,
      requiredError: ref(false),
    }
  },
  computed: {
    activeErrorMessage () {
      if (this.requiredError) {
        return `${this.label} is een verplicht veld`
      }
      return this.errorMessage
    },
    hasError () {
      if (this.requiredError) {
        return true
      }
      return this.error
    },
    cleanValue () {
      return this.strip_tags(this.modelValue).trim().replace(/\&nbsp;/g, '')
    },
  },
  methods: {
    updated (value) {
      this.requiredError = false
      this.$emit('update:modelValue', value)
    },
    checkRequired () {
      this.requiredError = this.required && !this.cleanValue
    },
  },
}
</script>
